module.exports = __webpack_public_path__ + "1a0f8435fc94dfb471ed9a9cc6db0049.pdf";